import { FormattedMessage, defineMessages } from 'react-intl';

import {
  FiatCurrency,
  FiatWalletAccountState,
} from '#src/__generated__/globalTypes.ts';
import { RadioGroup } from '#src/atoms/inputs/RadioGroup/index.tsx';
import { BodyS } from '#src/atoms/typography/index.tsx';
import { NeedsValidatedFiatWalletHelper } from '#src/components/fiatWallet/NeedsValidatedFiatWalletHelper/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useUpdateCurrency } from '#src/hooks/useUpdateCurrency.ts';
import { useFiatBalance } from '#src/hooks/wallets/useFiatBalance.ts';
import { EnterCashWalletKYCFlow_Source } from '#src/protos/events/platform/web/events.ts';

const messages = defineMessages({
  title: {
    defaultMessage: "What's your local currency?",
  },
  helper: {
    defaultMessage:
      'Activate your Cash Wallet to deposit and withdraw in your local currency.',
  },
  locked: {
    defaultMessage:
      "We don't support currency transfer on the cash wallet for now.",
  },
});

export const LocalCurrency = () => {
  const {
    fiatCurrency,
    walletPreferences: { showFiatWallet },
  } = useCurrentUserContext();
  const { isFiatWalletOwner } = useFiatBalance();
  const { updateCurrency } = useUpdateCurrency();

  if (!showFiatWallet) return null;

  const options = [
    {
      value: FiatCurrency.USD,
      label: FiatCurrency.USD,
      disabled: isFiatWalletOwner,
    },
    {
      value: FiatCurrency.EUR,
      label: FiatCurrency.EUR,
      disabled: isFiatWalletOwner,
    },
    {
      value: FiatCurrency.GBP,
      label: FiatCurrency.GBP,
      disabled: isFiatWalletOwner,
    },
  ];

  return (
    <SettingsSection title={messages.title}>
      <RadioGroup
        withSpacing
        options={options}
        value={fiatCurrency}
        name="fiatCurrency"
        onChange={updateCurrency('fiatCurrency')}
      />
      {isFiatWalletOwner ? (
        <BodyS color="var(--c-nd-600)">
          <FormattedMessage {...messages.locked} />
        </BodyS>
      ) : (
        <NeedsValidatedFiatWalletHelper
          defaultHelper={<FormattedMessage {...messages.helper} />}
          statusTarget={FiatWalletAccountState.OWNER}
          withPadding
          source={
            EnterCashWalletKYCFlow_Source.SETTINGS_CASH_AND_ETH_RECEIVED_PAYMENT_HELPER
          }
        />
      )}
    </SettingsSection>
  );
};
